'use client';

import Image from 'next/image';
import Autoplay from 'embla-carousel-autoplay';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel';
import { marqueeCredentials } from '@/data/credentialsData';

const PLUGINS = [
  Autoplay({ delay: 2000, stopOnInteraction: false, stopOnMouseEnter: true }),
];

/**
 * @param {Array}   [props.items]       Array of { href, src, alt, width, height }
 * @param {string}  [props.className]   Wrapper classes — controls bg color etc.
 * @param {boolean} [props.showMask]    Whether to show the left/right fade mask (default: true)
 * @param {string}  [props.cardHeight]  Tailwind height class for each logo card (default: 'h-24')
 */
export default function CredentialsMarquee({
  items = marqueeCredentials,
  className = 'bg-accent',
  showMask = true,
  cardHeight = 'h-20',
}) {
  const maskStyle = showMask
    ? {
      maskImage: 'linear-gradient(to right, transparent 0%, black 14%, black 56%, transparent 100%)',
      WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 14%, black 56%, transparent 100%)',
    }
    : {};

  return (
    <section className={`py-5 ${className}`}>
      <div className={`max-w-7xl mx-auto`}>
        <div style={maskStyle}>
          <Carousel
            opts={{ loop: true, align: 'start', dragFree: true }}
            plugins={PLUGINS}
          >
            <CarouselContent className="-ml-4">
              {items.map((item, i) => (
                <CarouselItem key={i} className="pl-4 basis-1/2 sm:basis-1/3 md:basis-1/4 lg:basis-1/5">
                  {item.href ? (
                    // Plain <a>: next/link would prefetch these (mostly PDF certificates, ~1.2 MB) on page load.
                    <a
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={item.alt}
                      className={`group relative flex items-center justify-center w-full ${cardHeight} rounded-2xl border border-slate-200 bg-white/80 shadow-sm hover:shadow-md hover:border-primary/40 transition-all duration-200 p-2`}
                    >
                      <Image
                        src={item.src}
                        alt={item.alt}
                        fill
                        sizes="(max-width: 640px) 50vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 20vw"
                        className="object-contain p-2"
                      />
                    </a>
                  ) : (
                    <div className={`relative flex items-center justify-center w-full ${cardHeight} rounded-2xl border border-slate-200 bg-white/80 shadow-sm p-2`}>
                      <Image
                        src={item.src}
                        alt={item.alt}
                        fill
                        sizes="(max-width: 640px) 50vw, (max-width: 768px) 33vw, (max-width: 1024px) 25vw, 20vw"
                        className="object-contain p-2"
                      />
                    </div>
                  )}
                </CarouselItem>
              ))}
            </CarouselContent>
          </Carousel>
        </div>
      </div>
    </section>
  );
}
